const toneStyles = {
  teal: "bg-teal-50 text-teal-700 ring-teal-100",
  blue: "bg-blue-50 text-blue-700 ring-blue-100",
  pink: "bg-pink-50 text-pink-700 ring-pink-100",
  yellow: "bg-amber-50 text-amber-700 ring-amber-100",
};

export default function MemberStatCard({ title, value, color = "teal", icon: Icon, detail }) {
  return (
    <div className="group rounded-2xl border border-slate-200/80 bg-white p-5 shadow-sm transition duration-200 hover:-translate-y-0.5 hover:shadow-md">
      <div className="flex items-start justify-between gap-3"><div><p className="text-sm font-medium text-slate-500">{title}</p><p className="mt-2 text-3xl font-semibold tracking-tight text-slate-900">{Number(value || 0).toLocaleString("th-TH")}</p></div>{Icon && <div className={`rounded-xl p-2.5 ring-1 ${toneStyles[color] || toneStyles.teal}`}><Icon size={20} strokeWidth={1.8} /></div>}</div>
      {detail && <p className="mt-3 text-xs text-slate-400">{detail}</p>}
    </div>
  );
}
